import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomDecimalInputWrapper, InputControls } from '../../components';
import { CustomFormItem } from '../../../custom_shared/components';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';
import { useNetDueCalculation } from '../../hooks';
import { InstanceUtils } from '../../misc';
import { TypeUtils } from '../../../common/misc';

const EntryCodeShareInput: InputWithoutSource = ({ input }) => {
    const { triggerNetDueCalculation } = useNetDueCalculation(input);

    const balanceInformationNode = React.useMemo(
        () => (InstanceUtils.isBalanceInformationNode(input.node.parentNode) ? input.node.parentNode : null),
        [input.node.parentNode]
    );

    const { label, labelTooltip } = React.useMemo(() => {
        const shareValue = balanceInformationNode?.signedShareValue;

        if (!TypeUtils.isNumber(shareValue)) {
            return { label: input.name };
        }

        return {
            label: `${input.name} (${parseFloat(shareValue.toFixed(2)).toString()}%)`,
            labelTooltip: `${shareValue} %`
        };
    }, [input.name, balanceInformationNode?.signedShareValue]);

    return (
        <CustomFormItem
            name={input.guid}
            required={input.required}
            isReadOnly={input.isReadOnly}
            message="This field is required. Fill in a value or remove this row before submission."
        >
            <CustomDecimalInputWrapper
                input={input}
                label={label}
                labelTooltip={labelTooltip}
                topRightNode={<InputControls input={input} />}
                onChange={triggerNetDueCalculation}
                showModifiedMarker={input.isModified}
            />
        </CustomFormItem>
    );
};

EntryCodeShareInput.meta = {
    inputType: InputModel.name
};

export default observer(EntryCodeShareInput);
